import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/recursos/caso-fashionable-canes-shopify-seo")({
  beforeLoad: () => {
    throw redirect({ to: "/es/recursos/caso-fashionable-canes-seo", statusCode: 301 });
  },
});
